// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import {
  ClearPosts,
  DeletePost,
  SetLoadingPosts,
  UpdatePost,
  UpdatePosts,
} from '@actions/campaign';

// Extend Array prototype for sortByProperty (declared elsewhere in the project)
declare global {
  interface Array<T> {
    sortByProperty(property: string, ascending?: boolean): T[];
  }
}

interface CampaignPost {
  _id: string;
  createdAt?: string;
  [key: string]: unknown;
}

export interface CampaignState {
  posts: CampaignPost[];
  isLoading: boolean;
}

type UpdatePostsPayload = CampaignPost[];
type SetLoadingPostsPayload = boolean;
type DeletePostPayload = string;
interface UpdatePostPayload extends Partial<CampaignPost> {
  _id: string;
}

type UpdatePostsAction = Action<UpdatePostsPayload>;
type SetLoadingPostsAction = Action<SetLoadingPostsPayload>;
type DeletePostAction = Action<DeletePostPayload>;
type UpdatePostAction = Action<UpdatePostPayload>;

const initialState: CampaignState = {
  posts: [],
  isLoading: false,
};

export default handleActions<
  CampaignState,
  | UpdatePostsPayload
  | SetLoadingPostsPayload
  | DeletePostPayload
  | UpdatePostPayload
  | void
>(
  {
    [UpdatePosts.toString()]: (
      state: CampaignState,
      { payload }: UpdatePostsAction,
    ): CampaignState => {
      return {
        ...state,
        posts: [...state.posts, ...payload].sortByProperty('createdAt', false),
      };
    },
    [SetLoadingPosts.toString()]: (
      state: CampaignState,
      { payload }: SetLoadingPostsAction,
    ): CampaignState => {
      return {
        ...state,
        isLoading: payload,
      };
    },
    [DeletePost.toString()]: (
      state: CampaignState,
      { payload }: DeletePostAction,
    ): CampaignState => {
      return {
        ...state,
        posts: state.posts.filter(({ _id }) => _id !== payload),
      };
    },
    [UpdatePost.toString()]: (
      state: CampaignState,
      { payload }: UpdatePostAction,
    ): CampaignState => {
      const { _id, ...otherPost } = payload;
      return {
        ...state,
        posts: state.posts.map((post) =>
          post?._id === _id ? { ...post, ...otherPost } : post,
        ),
      };
    },
    [ClearPosts.toString()]: (): CampaignState => {
      return initialState;
    },
  },
  initialState,
);
